import { Container } from '@/components/ui/Container'
import { Section } from '@/components/ui/Section'
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/Card'
import { missionVision } from '@/constants/company'

export function MissionVisionSection() {
  return (
    <Section surface="0">
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 md:gap-8">
          {/* Mission */}
          <Card surface="2">
            <CardHeader>
              <span className="font-mono text-xs uppercase tracking-wider text-fg-muted mb-1.5 sm:mb-2">
                Core Purpose
              </span>
              <CardTitle className="text-lg sm:text-xl md:text-2xl">
                Our Mission
              </CardTitle>
              <CardDescription className="mt-2.5 sm:mt-4 text-sm sm:text-base text-fg-subtle">
                {missionVision.mission}
              </CardDescription>
            </CardHeader>
          </Card>

          {/* Vision */}
          <Card surface="2">
            <CardHeader>
              <span className="font-mono text-xs uppercase tracking-wider text-fg-muted mb-1.5 sm:mb-2">
                Long-Term Horizon
              </span>
              <CardTitle className="text-lg sm:text-xl md:text-2xl">
                Our Vision
              </CardTitle>
              <CardDescription className="mt-2.5 sm:mt-4 text-sm sm:text-base text-fg-subtle">
                {missionVision.vision}
              </CardDescription>
            </CardHeader>
          </Card>
        </div>
      </Container>
    </Section>
  )
}
